export default __webpack_public_path__ + "images/information.e8637d0781809d52c8fbf7951317ee23.svg";